import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import TopUpWalletModal from "../topuprequest/TopUpWalletModal";
import AuthorizationModal from "../authorizationModal/authorizationModal";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import MWalletFilterModal from "./MWalletFilterModal";
import DateWiseRechargeReport from "./DateWiseRechargeReport";
import CustMainWalletAuditModal from "./CustMainWalletAuditModal";
import { format, parse } from "date-fns";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import FilterBar from "../common/FilterBar";
import { asStatusList } from "../common/filterOptions";

// Values are the backend's status keys
const WALLET_STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "INPROGRESS", label: "In-Progress" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "BLOCKED", label: "Blocked" },
];

const PROFILE_OPTIONS = [
  { value: "CUSTOMER", label: "Customer" },
  { value: "OPERATION", label: "Operation" },
];

// Helper function to get date 7 days ago in YYYY-MM-DD format
const getLast7DaysDate = () => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const year = sevenDaysAgo.getFullYear();
  const month = String(sevenDaysAgo.getMonth() + 1).padStart(2, "0");
  const day = String(sevenDaysAgo.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Helper function to get today's date in YYYY-MM-DD format
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const defaultFilterData = {
  customerId: "",
  fromAmount: "",
  toAmount: "",
  profile: "",
  status: [],
  fromDate: getLast7DaysDate(),
  toDate: getTodayDate(),
  search: "",
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

const TopUpMainWalletReq = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const userRole = sessionStorage.getItem("userRole");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [topUpReqData, setTopUpReqData] = useState([]);
  const [custData, setCustData] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [utrNo, setutrNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [smsBalance, setsmsBalance] = useState("");
  const [bankName, setBankName] = useState("");
  const [columnData, setColumnData] = useState("");
  const [rowData, setRowData] = useState("");
  const [auditData, setAuditData] = useState("");
  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState(defaultFilterData);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchTopUpMainWalletReqData(1, defaultFilterData);
  };

  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchCust();
  }, []);

  const fetchCust = () => {
    const requestBody = {
      username: loggedInUserName,
      // status: "1",
    };

    axiosPostApi(apiList.FETCH_CUSTOMER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const customerCode = response?.data?.data[0]?.customerCode;
          if (customerCode) {
            fetchTopUpMainWalletReqData(1);
          }
          setCustData(response?.data?.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching retailer data:", error);
      });
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };
    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const fetchTopUpMainWalletReqData = async (
    currentPage,
    filters = filterData,
    size = pageSize,
  ) => {
    console.log("::filters::", filters);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...filters,
        profile: filters.profile?.value || "",
        // amounts are numbers on the backend: send null, not ""
        fromAmount: filters.fromAmount === "" ? null : filters.fromAmount,
        toAmount: filters.toAmount === "" ? null : filters.toAmount,
        status: filters.status?.length > 0 ? filters.status : [],
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_MAIN_WALLET_HISTORY}?pageSize=${size}&pageNo=${currentPage}`,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setTopUpReqData(modifiedData);
        setNoData(modifiedData?.length === 0);
      } else {
        setNoData(true);
        setTopUpReqData([]);
      }
      fetchDashboardData();
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatIndianNumber = (value) => {
    if (!value && value !== 0) return value;
    return Number(value).toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      const transReqDate = user?.reqDate
        ? parse(user?.reqDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      return {
        ...user,
        reqDate: transReqDate
          ? [
              format(transReqDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(transReqDate, "HH:mm:ss"),
            ]
          : "",
        transactionDate: user.transactionDate?.split(" ")?.[0],

        amount: user?.amount
          ? `\u2003\u2003${formatIndianNumber(user.amount)}\u2003\u2003`
          : "-",

        customerNewBalance: user?.customerNewBalance
          ? `\u2003\u2003${formatIndianNumber(
              user.customerNewBalance,
            )}\u2003\u2003`
          : "-",

        customerCompanyName: `${user?.customerCompanyName || "N/A"} -   ${
          user?.customerId || "N/A"
        }`,

        lmbpName: user?.customerCompanyName || "N/A",
      };
    });
  };

  const topUpReqHeaders = [
    "Status",
    "Entry Date",
    ...(userRole !== "CUST" ? ["LMBP Name/Id"] : []),
    "Topup Amount(₹)",
    "Wallet Balance(₹)",
    "Txn Date",
    "LMBP Bank Name",
    "Pay Mode",
    "UTR No/Txn No",
    "Courier Bank Name",
    "Remark",
    "Attachment",
  ];

  if (userRole === "ACCMK" || userRole === "ACCCH") {
    topUpReqHeaders.splice(2, 0, "User Id", "LMBP Id", "LMBP Name");
  }

  const topUpReqHeaderToKeyMap = {
    Status: "authStatus",
    "Entry Date": "reqDate",
    "LMBP Name/Id": "customerCompanyName",
    "User Id": "username",
    "LMBP Id": "customerId",
    "LMBP Name": "customerCompanyName",
    "Topup Amount(₹)": "amount",
    "Wallet Balance(₹)": "customerNewBalance",
    "Txn Date": "txnDate",
    "LMBP Bank Name": "customerBankName",
    "Pay Mode": "payMode",
    "UTR No/Txn No": "utrNo",
    "Courier Bank Name": "bankName",
    Remark: "adminRemark",
    Attachment: "attachment",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handlerTopUpReqSMS = (id, actionType = "view") => {
    setColumnData(id);
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "delete") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerId);
      setsmsBalance(id.oldSmsBalance);
      setBankName(id?.bankName);
      setShowModal(true);
    } else if (actionType === "auth") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerId);
      setsmsBalance(id.oldSmsBalance);
      setBankName(id?.bankName);
      setShowModal(true);
    } else if (actionType === "modify") {
      setShowModal(true);
    } else if (actionType === "view") {
      let data = topUpReqData.find((item) => item.id === id?.id);
      if (data) {
        setEditData(data);
        setShowModal(true);
      }
    }
  };

  const handleFinalAuthorization = (authData, actionType) => {
    setModalAction(actionType);
    setShowModal(true);
    setRowData(authData);
    setColumnData(authData);
  };

  const handleAuditData = (data) => {
    setColumnData(data);
    fetchMainWalletAudit(data);
  };

  const fetchMainWalletAudit = async (custData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        id: custData?.id,
      };

      const response = await axiosPostApi(
        `${apiList.MAIN_WALLET_AUDIT_DATA}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditData);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      <HeaderWithBreadcrumb title="Main Wallet" breadcrumb="TopUp" />
      <FilterBar
        values={filterData}
        onChange={(next) => {
          setFilterData(next);
          setCurrentPage(1);
          fetchTopUpMainWalletReqData(1, next);
        }}
        search={{
          key: "search",
          placeholder: "Search LMBP code, user, company, UTR / RRN or bank",
        }}
        selects={[
          { key: "status", allLabel: "All statuses", chipLabel: "Status", options: WALLET_STATUS_OPTIONS, ...asStatusList },
          {
            key: "profile",
            allLabel: "All profiles",
            chipLabel: "Profile",
            options: PROFILE_OPTIONS,
            toValue: (stored) => stored?.value || "",
            fromOption: (option) => option || "",
          },
        ]}
        dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Requested" }}
      />
      <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              headers={topUpReqHeaders}
              data={topUpReqData}
              handleAction={handlerTopUpReqSMS}
              filterFields={[
                "customerId",
                "customerCompanyName",
                "customerBankName",
              ]}
              entityType="Top-up Wallet"
              headerToKeyMap={topUpReqHeaderToKeyMap}
              loading={loading}
              handleAuth={handleFinalAuthorization}
              pageDetails={pageDetails}
              noData={noData}
              currentPage={currentPage}
              // pageSize={pageSizeCount}
              pageSize={pageSize}
              totalRecord={totalRecord}
              setPageSize={setPageSize}
              // fetchNextData={fetchTopUpMainWalletReqData}
              fetchNextData={(pageNo) =>
                fetchTopUpMainWalletReqData(pageNo, filterData)
              }
              setCurrentPage={setCurrentPage}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => {}}
              handleAuditData={handleAuditData}
              hideFilterControls
            />

            {isModalOpenFilter ? (
              <MWalletFilterModal
                show={isModalOpenFilter}
                handleClose={closeModalFilter}
                setTopUpReqData={setTopUpReqData}
                setPageDetails={setPageDetails}
                setNoData={setNoData}
                currentPage={currentPage}
                pageSize={pageSize}
                filterData={filterData}
                setFilterData={setFilterData}
                handleReset={handleReset}
                defaultFilterData={defaultFilterData}
              />
            ) : null}
            {showModal && (
              <TopUpWalletModal
                show={showModal}
                handleClose={handleCloseModal}
                editData={editData}
                action={modalAction}
                data={topUpReqData}
                fetchData={() =>
                  fetchTopUpMainWalletReqData(currentPage, filterData)
                }
                customerData={custData}
                utrNo={utrNo}
                customerName={customerName}
                customerCode={customerCode}
                smsBalance={smsBalance}
                bankName={bankName}
                columnData={columnData}
              />
            )}
          </>
        )}

        {isModalOpenAudit ? (
          <CustMainWalletAuditModal
            show={isModalOpenAudit}
            handleClose={closeModalAudit}
            auditData={auditData}
          />
        ) : null}
      </div>

      <DateWiseRechargeReport />
    </div>
  );
};

export default TopUpMainWalletReq;
